var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _path55, _g22, _g23, _g24, _path56, _g25, _path57, _path58, _path59, _g26, _path60, _path61, _g27, _path62, _g28, _g29, _g30, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g31, _g32, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFarm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 35,
    viewBox: "0 0 47 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.765 25.221L30.4103 24.4648V34.1211H33.8129L33.765 25.221Z",
    fill: "#E96666"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.7291 25.0415H30.6207V25.1063H33.7291V25.0415Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7471 24.9448V25.6241L30.4103 24.6804V24.0081L33.7471 24.9448Z",
    fill: "#60352B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2744 5.50951C35.2744 5.5135 35.2734 5.5165 35.2734 5.51849V34.1212H33.7172V5.51849C33.7172 5.5165 33.7162 5.51351 33.7162 5.51051C33.7162 5.10651 34.0484 4.77731 34.4643 4.76235C34.4743 4.76135 34.4843 4.76135 34.4953 4.76135C34.9252 4.76135 35.2734 5.09553 35.2744 5.50951Z",
    fill: "#D8DCCB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1349 23.187H6.01318V34.1211H30.1349V23.187Z",
    fill: "#D65F5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8343 5.31897V7.49761C19.8343 7.49761 18.1345 6.80731 18.0267 6.78736C17.919 6.76741 16.3149 7.49761 16.3149 7.49761V5.31897H19.8343Z",
    fill: "#E96666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3022 5.52043V34.1202H35.2743V5.52043L35.2793 5.50946C35.2793 2.46694 37.7462 0 40.7877 0C40.9833 0 41.1768 0.0109718 41.3673 0.0299253C43.9061 0.295273 45.9331 2.28539 46.2533 4.80819C46.2563 4.83213 46.2593 4.85507 46.2613 4.88001C46.2743 4.99373 46.2842 5.10945 46.2902 5.22616C46.2902 5.23115 46.2902 5.23613 46.2912 5.24112C46.2952 5.3309 46.2982 5.41968 46.2982 5.51046C46.2982 5.51345 46.2982 5.51744 46.2972 5.52143H46.3022V5.52043Z",
    fill: "#D8DCCB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4518 5.44864H15.7224L16.2192 4.86109L16.3289 4.73041L16.8097 4.1618L16.9185 4.03312L17.3993 3.46452L17.509 3.33384L18.0357 2.71137L18.0387 2.70837L18.5894 3.33384L18.7041 3.46452L19.2049 4.03312L19.3186 4.1618L19.8203 4.73041L19.9351 4.86109L20.4518 5.44864Z",
    fill: "#D65F5F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9387 34.1212H0.0858154V35.0001H46.9387V34.1212Z",
    fill: "#D8DCCB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0626 6.86108L8.89609 11.8069L4.91687 22.5665H31.3679L27.2919 11.8409L18.0626 6.86108Z",
    fill: "#D65F5F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9053 16.3967H26.3942V18.6482H23.8115L23.9053 16.3967Z",
    fill: "#8AD2F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3295 10.2269H16.7559V12.5762H19.3295V10.2269Z",
    fill: "#8AD2F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3197 16.3967H9.6543V18.736H12.3197V16.3967Z",
    fill: "#8AD2F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1718 28.912H24.5975V32.0772H28.1718V28.912Z",
    fill: "#8AD2F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4429 28.912H8.00635V32.0772H11.4429V28.912Z",
    fill: "#8AD2F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44468 24.7252L0.728271 28.3373V34.1211H5.44468V24.7252Z",
    fill: "#D65F5F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20959 28.9119C2.2904 28.9109 3.97625 28.9119 3.97625 28.9119V32.0762H2.20959V28.9119Z",
    fill: "#8AD2F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.3112 5.59021H41.7594V34.1211H46.3022L46.3112 5.59021Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M35.2734 5.61523H34.6609V34.1192H35.2734V5.61523Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M35.2734 5.88049H35.0669V34.1201H35.2734V5.88049Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M36.0724 5.60925H35.2733V34.1232H36.0724V5.60925Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.9387 34.1212H0.0858154V34.5571H46.9387V34.1212Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.4517 5.44864H19.105L18.0356 2.71137L18.0386 2.70837L18.5893 3.33384L18.704 3.46452L19.2048 4.03312L19.3185 4.1618L19.8203 4.73041L19.935 4.86109L20.4517 5.44864Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M19.8333 5.44861H16.314V6.0212H19.8333V5.44861Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M30.1349 23.187H6.01318V23.7157H30.1349V23.187Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0.728271 28.3952L5.38882 24.9727V25.4894L0.728271 28.9289V28.3952Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22.9875 34.9303V27.6951H22.6015V34.9303H22.9875Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M19.0263 7.54342L18.5355 7.27808L10.0533 11.9247L9.30715 12.3346L9.03083 13.0948L5.47058 22.8907L6.20178 22.9795L10.0124 12.4583L19.0263 7.54342Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 28.4252L46.1087 28.5558L35.2743 28.6855V28.4252Z",
    fill: "#828579"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 29.8916L46.1087 29.9564L35.2743 30.0213V29.8916Z",
    fill: "#828579"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 31.2273L46.1087 31.357L35.2743 31.4867V31.2273Z",
    fill: "#828579"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 32.6927L46.1087 32.7576L35.2743 32.8234V32.6927Z",
    fill: "#828579"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 21.4862L46.1087 21.551L35.2743 21.6159V21.4862Z",
    fill: "#828579"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 22.822L46.1087 22.9527L35.2743 23.0824V22.822Z",
    fill: "#828579"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 24.2883L46.1087 24.3532L35.2743 24.418V24.2883Z",
    fill: "#828579"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 25.6241L46.1087 25.7538L35.2743 25.8835V25.6241Z",
    fill: "#828579"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 27.0895L46.1087 27.1543L35.2743 27.2192V27.0895Z",
    fill: "#828579"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 14.4176L46.1087 14.5473L35.2743 14.677V14.4176Z",
    fill: "#828579"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 15.8831L46.1087 15.9479L35.2743 16.0127V15.8831Z",
    fill: "#828579"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 17.2188L46.1087 17.3484L35.2743 17.4791V17.2188Z",
    fill: "#828579"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 18.6852L46.1087 18.75L35.2743 18.8149V18.6852Z",
    fill: "#828579"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 20.0209L46.1087 20.1506L35.2743 20.2802V20.0209Z",
    fill: "#828579"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 7.47766L46.1087 7.5435L35.2743 7.60834V7.47766Z",
    fill: "#828579"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 8.81445L46.1087 8.94413L35.2743 9.07382V8.81445Z",
    fill: "#828579"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 10.2798L46.1087 10.3446L35.2743 10.4095V10.2798Z",
    fill: "#828579"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 11.6155L46.1087 11.7452L35.2743 11.8758V11.6155Z",
    fill: "#828579"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2743 13.0819L46.1087 13.1467L35.2743 13.2116V13.0819Z",
    fill: "#828579"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3112 6.24072H35.2743V6.3704H46.3112V6.24072Z",
    fill: "#828579"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9114 6.30457H36.5233V34.1212H36.9114V6.30457Z",
    fill: "#828579"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.244 6.30457H37.9846V34.1212H38.244V6.30457Z",
    fill: "#828579"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6077 6.30457H39.4132V34.1212H39.6077V6.30457Z",
    fill: "#828579"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9393 6.30457H40.8745V34.1212H40.9393V6.30457Z",
    fill: "#828579"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3112 5.48047H35.2723V5.61015H46.3112V5.48047Z",
    fill: "#828579"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5567 1.59399C39.5567 1.59399 39.5198 1.64986 39.457 1.74762C39.4251 1.7965 39.3892 1.85735 39.3463 1.92618C39.3044 1.99601 39.2595 2.07581 39.2106 2.1626C39.1647 2.25138 39.1108 2.34515 39.062 2.4479C39.0101 2.54965 38.9612 2.65938 38.9093 2.7731C38.8615 2.88782 38.8086 3.00553 38.7637 3.12822C38.7158 3.24993 38.6739 3.37562 38.63 3.50131C38.5911 3.628 38.5482 3.75369 38.5163 3.88037C38.4993 3.94322 38.4824 4.00607 38.4654 4.06791C38.4505 4.12976 38.4365 4.19161 38.4215 4.25246C38.3906 4.37317 38.3717 4.49188 38.3467 4.60261C38.3258 4.71433 38.3088 4.82107 38.2919 4.91883C38.2779 5.01758 38.2659 5.10736 38.2549 5.18717C38.243 5.26697 38.238 5.3368 38.231 5.39466C38.219 5.50938 38.2121 5.57522 38.2121 5.57522L38.0834 5.56225C38.0834 5.56225 38.0924 5.49541 38.1083 5.37969C38.1173 5.32184 38.1243 5.25101 38.1382 5.17021C38.1522 5.08941 38.1672 4.99863 38.1841 4.89987C38.2041 4.80112 38.224 4.69438 38.249 4.58165C38.2769 4.46993 38.3008 4.35122 38.3348 4.23052C38.3507 4.16966 38.3677 4.10882 38.3846 4.04597C38.4036 3.98412 38.4225 3.92128 38.4415 3.85843C38.4784 3.73174 38.5253 3.60605 38.5682 3.48036C38.6151 3.35567 38.6619 3.22997 38.7138 3.10927C38.7627 2.98757 38.8186 2.86986 38.8704 2.75614C38.9253 2.64342 38.9782 2.53468 39.034 2.43393C39.0869 2.33218 39.1428 2.23941 39.1916 2.15163C39.2435 2.06584 39.2904 1.98803 39.3353 1.9192C39.3802 1.85136 39.4181 1.79151 39.451 1.74363C39.5188 1.64886 39.5567 1.59399 39.5567 1.59399Z",
    fill: "#828579"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4485 5.49046C36.4485 5.49046 36.4565 5.39569 36.4714 5.2311C36.4754 5.1902 36.4794 5.14431 36.4834 5.09443C36.4884 5.04456 36.4904 4.99069 36.5024 4.93283C36.5223 4.81712 36.5442 4.68544 36.5682 4.54279C36.5981 4.40113 36.641 4.25151 36.6809 4.0919C36.7019 4.01209 36.7338 3.93328 36.7607 3.85149C36.7896 3.76969 36.8156 3.68589 36.8495 3.6021C36.8854 3.5203 36.9223 3.4365 36.9592 3.35171C36.9782 3.30982 36.9951 3.26692 37.0161 3.22503C37.038 3.18413 37.06 3.14223 37.0819 3.10033C37.1268 3.01754 37.1697 2.93274 37.2166 2.84995C37.2675 2.76915 37.3183 2.68835 37.3692 2.60754C37.4181 2.52475 37.477 2.44993 37.5328 2.37312C37.5897 2.2973 37.6416 2.2175 37.7044 2.14767C37.7643 2.07585 37.8241 2.00403 37.883 1.9332C37.9458 1.86636 38.0077 1.79953 38.0685 1.73469C38.1284 1.66785 38.1922 1.60899 38.255 1.54914C38.3179 1.49029 38.3757 1.42944 38.4396 1.37757C38.5014 1.3247 38.5613 1.27282 38.6201 1.22195C38.679 1.17207 38.7389 1.12818 38.7947 1.08429C38.9054 0.994506 39.0142 0.922683 39.1079 0.853852C39.2037 0.788014 39.2885 0.734143 39.3573 0.688256C39.499 0.602466 39.5798 0.553589 39.5798 0.553589C39.5798 0.553589 39.5 0.60546 39.3613 0.695239C39.2935 0.743121 39.2097 0.798987 39.1169 0.866821C39.0262 0.937647 38.9194 1.01246 38.8117 1.10524C38.7578 1.15112 38.699 1.19701 38.6421 1.24789C38.5852 1.29976 38.5274 1.35263 38.4675 1.40749C38.4057 1.46036 38.3498 1.52321 38.29 1.58306C38.2301 1.64391 38.1683 1.70476 38.1104 1.7726C38.0515 1.83844 37.9927 1.90626 37.9318 1.9741C37.876 2.04592 37.8191 2.11775 37.7613 2.19057C37.7014 2.2614 37.6525 2.3412 37.5987 2.41801C37.5468 2.49582 37.4899 2.57163 37.445 2.65343C37.3972 2.73423 37.3493 2.81503 37.3024 2.89583C37.2585 2.97863 37.2186 3.06242 37.1767 3.14522C37.1557 3.18612 37.1358 3.22802 37.1158 3.26892C37.0969 3.31082 37.0809 3.35371 37.064 3.3956C37.0301 3.4794 36.9961 3.56219 36.9632 3.64399C36.9323 3.72579 36.9094 3.80959 36.8834 3.89039C36.8595 3.97119 36.8305 4.049 36.8126 4.12781C36.7787 4.28542 36.7408 4.43306 36.7158 4.56972C36.6959 4.70738 36.6789 4.83407 36.663 4.9458C36.653 5.00066 36.653 5.05653 36.649 5.1054C36.646 5.15528 36.643 5.20117 36.641 5.24207C36.631 5.40766 36.626 5.50243 36.626 5.50243L36.4485 5.49046Z",
    fill: "#828579"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.2765 15.8131H7.87061V15.9428H28.2765V15.8131Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.862 17.2097H26.5068V17.3394H28.862V17.2097Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.8424 17.2097H12.2888V17.3394H23.8424V17.2097Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.76307 17.2097H7.28516V17.3394H9.76307V17.2097Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.305 18.6063H26.4919V18.736H29.305V18.6063Z",
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.8115 18.6063H12.3197V18.736H23.8115V18.6063Z",
    fill: "black"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.65423 18.6063H6.84314V18.736H9.65423V18.6063Z",
    fill: "black"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.8955 20.0039H6.25159V20.1336H29.8955V20.0039Z",
    fill: "black"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.3903 21.4004H5.75781V21.5301H30.3903V21.4004Z",
    fill: "black"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.3924 8.83032H14.7548V8.96H21.3924V8.83032Z",
    fill: "black"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.9052 10.2269H19.4521V10.3566H23.9052V10.2269Z",
    fill: "black"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.7558 10.2269H12.2429V10.3566H16.7558V10.2269Z",
    fill: "black"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.461 11.6234H19.3904V11.7531H26.461V11.6234Z",
    fill: "black"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.7559 11.6234H9.68726V11.7531H16.7559V11.6234Z",
    fill: "black"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.3508 13.02H8.79736V13.1497H27.3508V13.02Z",
    fill: "black"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.8446 14.4166H8.30359V14.5463H27.8446V14.4166Z",
    fill: "black"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.8976 7.43372H17.2506V7.5634H18.8976V7.43372Z",
    fill: "black"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.7041 3.46454H17.3993L17.509 3.33386H18.5894L18.7041 3.46454Z",
    fill: "black"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3185 4.16176H16.8097L16.9184 4.03308H19.2048L19.3185 4.16176Z",
    fill: "black"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.935 4.86103H16.2191L16.3288 4.73035H19.8203L19.935 4.86103Z",
    fill: "black"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1708 30.4781L30.135 30.543L28.1708 30.6078V30.4781Z",
    fill: "black"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.5676 30.4781H22.4269V30.6078H24.5676V30.4781Z",
    fill: "black"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.5866 30.4781H11.6614V30.6078H13.5866V30.4781Z",
    fill: "black"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.00629 30.4781H6.01318V30.6078H8.00629V30.4781Z",
    fill: "black"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.3451 33.2722L30.0043 33.3371L22.3451 33.4009V33.2722Z",
    fill: "black"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.5866 33.2722H5.88953V33.4019H13.5866V33.2722Z",
    fill: "black"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.99329 23.4952L30.135 23.5601L5.99329 23.6249V23.4952Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.99329 24.8918L30.135 24.9567L5.99329 25.0215V24.8918Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5735 27.6849L30.1349 27.7498L22.5735 27.8146V27.6849Z",
    fill: "black"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.5547 27.6849H5.97034V27.8146H13.5547V27.6849Z",
    fill: "black"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.36658 27.6849L5.38869 27.7498L1.36658 27.8146V27.6849Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.97522 30.4781L5.44461 30.543L3.97522 30.6078V30.4781Z",
    fill: "black"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.11885 30.4781H0.728271V30.6078H2.11885V30.4781Z",
    fill: "black"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.728271 33.2722L5.3549 33.3371L0.728271 33.4009V33.2722Z",
    fill: "black"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.7162 33.4209H30.6078V33.4857H33.7162V33.4209Z",
    fill: "black"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.7162 27.8346H30.6078V27.8994H33.7162V27.8346Z",
    fill: "black"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.7162 30.6277H30.6078V30.6925H33.7162V30.6277Z",
    fill: "black"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M19.524 12.7697H16.6232V10.0653H19.524V12.7697ZM17.0122 12.3816H19.136V10.4544H17.0122V12.3816Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2682 10.2599H17.8801V12.5762H18.2682V10.2599Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3295 11.2235H16.8176V11.6116H19.3295V11.2235Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4364 18.9065H9.53552V16.2021H12.4364V18.9065ZM9.92457 18.5185H12.0483V16.5912H9.92457V18.5185Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1805 16.3967H10.7925V18.713H11.1805V16.3967Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2419 17.3604H9.7301V17.7484H12.2419V17.3604Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6644 32.2707H7.84375V28.7184H11.6644V32.2707ZM8.2318 31.8826H11.2753V29.1064H8.2318V31.8826Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94749 28.9119H9.55945V32.0761H9.94749V28.9119Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14688 32.2707H2.05103V28.7184H4.14688V32.2707ZM2.44007 31.8826H3.75883V29.1064H2.44007V31.8826Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3045 32.2707H24.4839V28.7184H28.3045V32.2707ZM24.8719 31.8826H27.9155V29.1064H24.8719V31.8826Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5876 28.9119H26.1996V32.0761H26.5876V28.9119Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6116 18.9065H23.7107V16.2021H26.6116V18.9065ZM24.0997 18.5185H26.2235V16.5912H24.0997V18.5185Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3547 16.3967H24.9667V18.713H25.3547V16.3967Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4171 17.3604H23.9053V17.7484H26.4171V17.3604Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.2217L5.39973 24.2015V24.9637L0 28.9788V28.2217Z",
    fill: "#60352B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.369 28.7025V29.3409L10.1989 32.0563H9.92358L11.369 28.7025Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01226 22.6543H5.38879V34.1211H6.01226V22.6543Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4459 27.8137H13.7383V34.7577H22.4459V27.8137Z",
    fill: "#B45D5D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M21.8064 28.4102H14.3397L13.9327 28.078H22.2124L21.8064 28.4102Z",
    fill: "black"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M21.9311 34.8504L13.7811 28.4102L13.8609 27.9773L22.365 34.6978L21.9311 34.8504Z",
    fill: "black"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M14.2978 34.8504L13.7013 34.8265L22.369 27.9773L22.4458 28.4112L14.2978 34.8504Z",
    fill: "black"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8605 27.7322L13.6199 28.0366L22.2872 34.8857L22.5278 34.5812L13.8605 27.7322Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2816 27.732L13.6143 34.58L13.8548 34.8844L22.5222 28.0365L22.2816 27.732Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6025 34.9291H13.5458V27.6909H22.6015V34.9291H22.6025ZM13.9348 34.5411H22.2135V28.08H13.9348V34.5411Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M30.6537 23.187V34.1221H36.5402L32.3685 23.0244L31.6223 23.187H30.6537Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.3112 5.90447C46.3112 11.9676 46.3022 34.1201 46.3022 34.1201H43.1819C43.1819 34.1201 43.1819 10.5351 43.1819 5.52041V5.37178C43.136 2.09184 42.1225 0.721209 41.3663 0.0299072C43.9051 0.295255 45.9321 2.28537 46.2523 4.80817C46.2553 4.83211 46.2583 4.85505 46.2603 4.87999C46.2713 4.99271 46.2803 5.10843 46.2892 5.22614C46.2892 5.23113 46.2892 5.23611 46.2902 5.2411C46.3032 5.45358 46.3112 5.67604 46.3112 5.90447Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.3012 33.6873H33.7311V34.1212H46.3012V33.6873Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.3555 28.9788L9.02979 32.0562H9.46871L10.7944 28.9788H10.3555Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.26617 28.9788L7.94043 32.0562H8.4412L9.76794 28.9788H9.26617Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.9962 28.7025V29.3409L26.8261 32.0563H26.5508L27.9962 28.7025Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.9837 28.9788L25.657 32.0562H26.0959L27.4216 28.9788H26.9837Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.8934 28.9788L24.5676 32.0562H25.0684L26.3951 28.9788H25.8934Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.54327 29.0048L2.21753 32.0822H2.7193L4.04504 29.0048H3.54327Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4.01512 29.9364L3.05847 32.1559H3.33379L4.01512 30.5748V29.9364Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.09935 28.7025L2.1427 30.9221H2.41802L3.23003 29.0417L3.09935 28.7025Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.5307 29.9364L10.5751 32.1559H10.8504L11.6614 30.2756L11.5307 29.9364Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.8004 28.8262L7.84375 31.0457H8.11907L8.93108 29.1653L8.8004 28.8262Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.116 30.2008L27.274 32.156H27.5494L28.116 30.8412V30.2008Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.2685 16.5892L25.4255 18.5444H25.7009L26.2685 17.2297V16.5892Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.8674 16.3967L24.9576 18.5075H25.233L26.1427 16.3967H25.8674Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.9647 16.3967L24.0549 18.5075H24.4939L25.4036 16.3967H24.9647Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.0493 16.5892L11.2064 18.5444H11.4817L12.0493 17.2297V16.5892Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.6494 16.3967L10.7386 18.5075H11.015L11.9247 16.3967H11.6494Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.7466 16.3967L9.83679 18.5075H10.2747L11.1845 16.3967H10.7466Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.143 10.5361L18.3 12.4913H18.5754L19.143 11.1776V10.5361Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.7419 10.3446L17.8322 12.4554H18.1075L19.0172 10.3446H18.7419Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.8392 10.3446L16.9304 12.4554H17.3683L18.2781 10.3446H17.8392Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6746 22.3381L26.9118 12.0145L18.0735 7.14047L9.23626 12.0145L5.4735 22.3381L4.19165 23.4853L3.77966 23.0244L4.9458 21.981L8.73449 11.5845L18.0745 6.4342L27.4126 11.5845L31.2023 21.981L32.3684 23.0244L31.9564 23.4853L30.6746 22.3381Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6537 22.6543H30.135V34.1221H30.6537V22.6543Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6901 22.5665H4.38318V23.187H31.6901V22.5665Z",
    fill: "#F2F2F2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6746 22.3381L26.9118 12.0145L18.0735 7.14047L9.23626 12.0145L5.4735 22.3381L4.32732 23.3476L3.97518 23.2429L3.77966 23.0244L4.9458 21.981L8.73449 11.5845L18.0745 6.4342L27.4126 11.5845L31.2023 21.981L32.3684 23.0244L32.1729 23.2429L31.9185 23.4524L30.6746 22.3381Z",
    fill: "#60352B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M31.739 23.7277L30.3973 22.5257L26.6475 12.24L18.0736 7.51159L9.49965 12.24L5.75086 22.5257L4.40816 23.7277L3.97522 23.2429L5.19622 22.1506L8.97294 11.7881L18.0736 6.76941L27.1752 11.7881L30.9519 22.1506L32.1729 23.2439L31.739 23.7277Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.8f05122fe52400df86274697fe3565e2.svg";
export { ForwardRef as ReactComponent };